import React, { useCallback, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import { fg } from '@atlaskit/platform-feature-flags';
import TextArea from '@atlaskit/textarea';
export const EditParagraph = ({
  id,
  value,
  isInvalid,
  isRequired,
  onChange
}) => {
  // Local state required to show textarea changes as onChange callback is debounced.
  // Without it, user will only see their last inputted character added within the debounce period.
  const [textAreaValue, setTextAreaValue] = useState(value);
  useEffect(() => {
    if (fg('debounce_proforma_text_field_edits')) {
      setTextAreaValue(value);
    }
  }, [value]);
  const debouncedOnChange = useMemo(() => fg('debounce_proforma_text_field_edits') ? onChange ? debounce(onChange, 500) : noop : noop, [onChange]);
  const handleTextAreaChange = useCallback(e => {
    e.persist();
    setTextAreaValue(e.target.value);
    debouncedOnChange(e);
  }, [debouncedOnChange]);
  return /*#__PURE__*/React.createElement(TextArea, {
    appearance: "standard",
    isCompact: false,
    isDisabled: false,
    isReadOnly: false,
    isInvalid: isInvalid,
    isRequired: fg('proforma_a11y_mandatory_fields') ? isRequired : undefined,
    minimumRows: 5,
    maxHeight: "none",
    isMonospaced: false,
    value: fg('debounce_proforma_text_field_edits') ? textAreaValue : value,
    defaultValue: undefined,
    resize: "smart",
    spellCheck: false,
    onBlur: undefined,
    onChange: fg('debounce_proforma_text_field_edits') ? handleTextAreaChange : onChange,
    onFocus: undefined,
    id: id
  });
};